// Load utility defaults before component Sass so className overrides retain their precedence.
import '@/styles/tailwind.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';

import { App } from '@/components/App';
import { Loader } from '@/components/shared/loaders/Loader';
import { ErrorPage } from '@/components/ErrorPage';
import { Config, type EnvConfig } from '@/utils/environment';
import { Api } from '@/utils/api';
import { AuthHelper } from '@/utils/firebase';
import '@stripe/connect-js';

import 'swiper/css';
import 'swiper/css/navigation';

import '@/initializers/clearTrackingCookies';
import '@/initializers/i18n';
import '@/initializers/yup';
import '@/initializers/scrollbarActivation';
import '@/styles/application.sass';

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(<Loader />);

if (!window.location.pathname.includes('/app')) {
  window.history.replaceState(null, '', `/app${window.location.pathname}`);
}

const initialize = async () => {
  try {
    const response = await axios.get<EnvConfig>('/env.json');

    const config = response.data;

    await Config.initialize(config);

    await Api.initialize(config);
    await AuthHelper.initialize(config);

    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  } catch (error) {
    console.error(error);
    root.render(<ErrorPage error={error instanceof Error ? error : undefined} />);
  }
};

initialize();
